exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".containerTitle{\n  font-size:60px;\n  font-weight: 900;\n  color: white;\n  text-align:left;\n}\n.skillsContainer{\n  padding: 15rem 20px;\n  margin: 2rem 0 5rem;\n  text-align: center;\n}\n.computer {\n    width: 300px;\n    margin: 2rem 0 2.5rem;\n}\n.skill{\n    font-size: 27px;\n    color: white;\n    -webkit-box-shadow: 0px 0px 21px 0px rgba(0,0,0,0.4);\n    box-shadow: 0px 0px 21px 0px rgba(0,0,0,0.4);\n    padding-top: 15px;\n    background: #0000001a;\n}\n.logo {\n    width: 115px;\n}\n.computerTitle {\n    margin: 2rem 0 2.5rem;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/Putman/Desktop/Javascript Projects/angular-portfolio/src/app/skills/skills.component.css
// module id = ../../../../../src/app/skills/skills.component.css
// module chunks = main